import { useQuery } from '@tanstack/react-query';
import DOMPurify from 'dompurify';

// Keep SVG markup intact, strip scripts/handlers. Mirrors the sanitize config
// used by the overview diagram (we can't import across feature folders).
const SANITIZE_OPTS = { USE_PROFILES: { svg: true, svgFilters: true } };

/**
 * Fetches and sanitizes a same-origin /public SVG for the furnace hero.
 * Self-contained (no cross-feature import). Returns the safe markup string.
 */
export function useFurnaceSvg(svgUrl) {
  return useQuery({
    queryKey: ['liveMode', 'furnace-svg', svgUrl],
    enabled: !!svgUrl,
    staleTime: 10 * 60_000,
    retry: false,
    queryFn: async () => {
      const res = await fetch(svgUrl);
      if (!res.ok) throw new Error(`Could not load furnace SVG — HTTP ${res.status}`);
      return DOMPurify.sanitize(await res.text(), SANITIZE_OPTS);
    },
  });
}
